export default "__VITE_ASSET__Bs$ggn2T__"